//详情类型记录
export function getDetailType() {
  return localStorage.getItem("DetailType");
}

export function setDetailType(type) {
  localStorage.setItem("DetailType", type);
}

export function isDetailType() {
  if (localStorage.getItem("DetailType")) {
    return true;
  }
  return false;
}

export function getBgColor() {
  return localStorage.getItem("BgColor");
}

export function setBgColor(data) {
  localStorage.setItem("BgColor", data);
}

// 获取用户信息
export function getUserInfoToLocal() {
  const userInfo = JSON.parse(localStorage.getItem("userInfo-dots"));

  return {
    id: userInfo?.id,
    userType: userInfo?.userType,
    name: userInfo?.name,
    uid: userInfo?.uid,
    isOverseas: userInfo?.isOverseas,
    verify: userInfo?.verify,
    deptIds: userInfo?.deptIds,
    roleIds: userInfo?.roleIds,
    supplierId: userInfo?.supplierId,
    isLimit: userInfo?.isLimit
  };
}

// 获取用户手机号邮箱
export function getUserInfoToLocalEmailPhone() {
  const userInfo = JSON.parse(
    localStorage.getItem("userInfo-dots-email-phone")
  );

  return {
    mobile: userInfo?.mobile,
    email: userInfo?.email,
    verify: userInfo?.verify,
  };
}

//清除用户信息 （包含token, user, supplierbase 等所有用户相关的信息），退出时调用
export function clearAccountInfo() {
  // const keysToExclude = ['dots-examInfo'];
  // // 清除除了特定项之外的所有缓存项
  // for (let i = 0; i < localStorage.length; i++) {
  //   const keyName = localStorage.key(i);
  //   if (!keysToExclude.includes(keyName)) {
  //     localStorage.removeItem(keyName);
  //   }
  // }
  //------------------以上方法会导致缓存清楚不干净
  const examInfo = localStorage.getItem("dots-examInfo");
  localStorage.clear();
  localStorage.setItem("dots-examInfo", examInfo);
  sessionStorage.clear();
}

export function getVersion() {
  const version = sessionStorage.getItem("dots-oldversion");
  if (version !== null) {
    return version
  }
  if (process.env.REACT_APP_BASE_URL.includes('uat')) {
    sessionStorage.setItem("dots-oldversion", "1");
    return '1'
  }
  return null
}
